import MaatregelenObjectTemplate from "./MaatregelenObjectTemplate";

export default MaatregelenObjectTemplate;